import { Component, OnInit } from '@angular/core';
import { UtilsService } from '../utils.service';
import { TemplateService } from '../template.service';
import { LoginService } from '../login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.css']
})
export class TemplateComponent implements OnInit {

  public template = {
    idUsuario: 0,
    descricao: '',
    tipoProjeto: '',
    atividades: []
  }
  public tipoProjeto: Object = {};
  progressBar: boolean = false;
  constructor(private tempServ: TemplateService,
              private loginServ: LoginService,
              public router: Router) { }

  ngOnInit() {
    this.tipoProjeto = UtilsService.getEnums("TIPO_PROJETO");
    setTimeout(function () {
      UtilsService.setDate();
      UtilsService.setSelect();
      eval('document.getElementsByClassName("dropdown-content").style = "height: 250px !important"')
    }, 100);
  }

  ngAfterViewInit() {
    
    this.template.idUsuario = this.loginServ.getUsuario("id");
    setTimeout(function () {
      let className = document.querySelector('#tamWidth').className.replace('s12', '');
      document.querySelector('#tamWidth').className += ' ' + (screen.availWidth <= 992 ? 's12' : 's8');
    }, 500);
  }

  setTipo() {
    this.template.atividades = [];

    if (this.template.tipoProjeto !== '') {
      this.progressBar = true;
      this.tempServ.getSugestao(this.template.tipoProjeto).subscribe((resp) => {
        this.progressBar = false;
        console.log(resp);
        this.template.atividades = resp["atividades"];
        setTimeout(() => {
          UtilsService.setDate();
          UtilsService.setSelect();
        }, 100);
      });
    }
  }

  salvar() {
    if (this.template["descricao"] == '') {
      UtilsService.alerta("Descrição é obrigatória!", "erro");
      return;
    } else if (this.template["tipoProjeto"] == '') {
      UtilsService.alerta("Tipo de projeto é obrigatório!", "erro");
      return;
    } else if (this.template.atividades.length == 0) {
      UtilsService.alerta("Favor adicionar pelo menos uma atividade!", "erro");
      return;
    }
    
    this.progressBar = true;
    let form:any = {
      "idUsuario" : this.template["idUsuario"],
      "descricao" : this.template["descricao"],
      "tipoProjeto" : this.template["tipoProjeto"],
      "atividades" : []
    }

    for (let idx = 0; idx < this.template.atividades.length; idx++) {
      form["atividades"][idx] = {};
      form["atividades"][idx]["tarefas"] = [];
      form["atividades"][idx]["descricaoAtividade"] = this.template["atividades"][idx]["descricaoAtividade"];
      if (this.template["atividades"][idx]["tarefas"] !== undefined)
        for (let idx2 = 0; idx2 < this.template["atividades"][idx]["tarefas"].length; idx2++) {
          form["atividades"][idx]["tarefas"][idx2] = {};
          form["atividades"][idx]["tarefas"][idx2]["descricao"] = this.template["atividades"][idx]["tarefas"][idx2]["descricao"];
        }
    }

    this.tempServ.salvarTemplate(form).subscribe((resp) => {
      this.progressBar = false;
      setTimeout(function () {
        document.querySelector('#tamWidth').className += (screen.availWidth <= 992 ? 'S12' : 'S6');
        UtilsService.setDate();
        UtilsService.setSelect();
      }, 500);
      console.log(resp);
      UtilsService.alerta("Cadastro do template efetuado com sucesso!");
      this.router.navigate(['/projetos/']);
    }, (resp) => {
      this.progressBar = false;
      setTimeout(function () {
        document.querySelector('#tamWidth').className += (screen.availWidth <= 992 ? 'S12' : 'S6');
        UtilsService.setDate();
        UtilsService.setSelect();
        UtilsService.alerta(resp.error.message, 'erro');
      }, 500);
    });
  }

  idxAtividade:number = 0;
  addAtividade() {
    this.template.atividades.unshift({
      id: this.idxAtividade++,
      descricaoAtividade: '',
      tarefas: []
    })
  }

  idxTarefa:number = 0;
  addTarefa(ativ) {
    if (ativ.tarefas == undefined)
      ativ.tarefas = [];

    ativ.tarefas.unshift({
      id: this.idxTarefa++,
      descricao: ''
    })
  }

  removerAtividade(item: Object) {
    for (let mem in this.template.atividades) {
      if (this.template.atividades[mem] == item)
      this.template.atividades.splice(parseInt(mem), 1);
    }
  }

  removerTarefa(item: Object) {
    console.log(item);
    for (let mem = 0; mem < this.template.atividades.length; mem++) {
      if (this.template.atividades[mem]["tarefas"] !== undefined)
        for (let mem2 = 0; mem2 < this.template.atividades[mem]["tarefas"].length; mem2++) {
          if (this.template.atividades[mem]["tarefas"][mem2] == item)
          this.template.atividades[mem]["tarefas"].splice(mem2, 1);
        }
    }
  }
}
